// IngredientsSection.jsx
import React from "react";
import {
  Section,
  Container,
  Header,
  Kicker,
  Title,
  Divider,
  Grid,
  Item,
  IconWrap,
  IconCircle,
  ItemTitle,
  ItemText,
  IconImg,
} from "./IngredientsSectionStyles";

import Fistic from "../../assets/CalitatePage/Fistic.png";
import Ciocolata from "../../assets/CalitatePage/Ciocolata.png";
import Fructe from "../../assets/CalitatePage/Fructe.png";
import Frisca from "../../assets/CalitatePage/Frisca.png";
import Vanilie from "../../assets/CalitatePage/Vanilie.png";
import Visine from "../../assets/CalitatePage/Visine.png";

export default function IngredientsSection() {
  const ingredients = [
    {
      title: "Vanilie Bourbon",
      text: "Madagascar – aromă naturală intensă, pură și elegantă.",
      icon: Vanilie,
    },
    {
      title: "Ciocolată Belgiană",
      text: "Callebaut – note echilibrate, textură fină, profunzime autentică.",
      icon: Ciocolata,
    },
    {
      title: "Fistic 100% Pur",
      text: "Gust bogat, ușor prăjit, pentru contraste rafinate.",
      icon: Fistic,
    },
    {
      title: "Vișine Amarena",
      text: "Italia – dulci-acrișoare, pentru echilibru și finețe.",
      icon: Visine,
    },
    {
      title: "Frișcă & Unt 82%",
      text: "Textură stabilă, cremă catifelată, rafinament pur.",
      icon: Frisca,
    },
    {
      title: "Fructe proaspete",
      text: "Prospețime autentică, direct de la producători locali.",
      icon: Fructe,
    },
  ];

  return (
    <Section>
      <Container>
        <Header>
          <Kicker>Ingrediente Premium</Kicker>
          <Title>Esența fiecărui desert</Title>
          <Divider />
        </Header>

        <Grid>
          {ingredients.map((item, index) => (
            <Item key={index}>
              <IconWrap>
                <IconCircle>
                  <IconImg src={item.icon} alt={item.title} />
                </IconCircle>{" "}
              </IconWrap>

              <ItemTitle>{item.title}</ItemTitle>
              <ItemText>{item.text}</ItemText>
            </Item>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}
